// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"TermsOfUse_bodyWrapper__VsxgT","boldItalic":"TermsOfUse_boldItalic__YI606","bold":"TermsOfUse_bold__PRv-z"};